import {
  type IParseThemeValidationContext,
  type IUseThemeValidationContext,
} from '@framework/theme/engine/useThemeValidationContext.ts';
import { useMemo } from 'react';

export const useThemeValidationContext: IUseThemeValidationContext = () => {
  return useMemo(() => parseThemeValidationContext({}), []);
};

export const parseThemeValidationContext: IParseThemeValidationContext = () => {
  return {};
};
